export default "__VITE_ASSET__C8yE7hyA__"